/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label } from "reactstrap";
import { decodeLayout } from "../layouts/LayoutPortalUtil";
import CaptivePortal from "./CaptivePortal";
import CaptivePortalContainer from "./CaptivePortalContainer";
import LoadingSpinner from "../../elements/LoadingSpinner";

const CaptivePortalPreview = ({
  placeholder = "Could not preview layout",
  config,
  loading = false,
  selectedLayer,
  selectedId,
  width = 340,
  height = 510,
  style = {
    border: "1px solid #AAA",
    borderRadius: "12px",
    backgroundColor: "#EEE"
  }
}) => {
  // helpers
  const layout = decodeLayout(config);
  const captivePortalDimension = { width: width, height: height };

  return (
    <div className="fill-container d-flex justify-content-center">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div style={{
          width: captivePortalDimension.width + 1,
          height: captivePortalDimension.height + 1,
          overflow: "hidden",
          ...style
        }}>
          {layout == null ? (
            <div className="fill-container d-flex justify-content-center align-items-center">
              <Label className="w-100 text-center" size="sm">{placeholder}</Label>
            </div>
          ) : (
            <CaptivePortalContainer
              layout={layout}
              showSplashScreen={false}
              absolutePosition={false}
              interactable={false}
              dimension={captivePortalDimension}
            >
              <CaptivePortal
                layout={layout}
                dimension={captivePortalDimension}
                selectedLayer={selectedLayer}
                selectedId={selectedId}
                preview
              />
            </CaptivePortalContainer>
          )}
        </div>
      )}
    </div>
  );
};

export default CaptivePortalPreview;
